import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from "antd";


export const BotonCerrarSesion = () => {

    const navigator = useNavigate();

    const cerrarSesion = () => {

      navigator("/");

    }

    return <Button type="primary" onClick={() => cerrarSesion()} >Cerrar sesión</Button>;

}